import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=4a2b7c9c"
import script from "./Discount.vue?vue&type=script&lang=ts"
export * from "./Discount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports